(function () {
    var module = angular.module('sdFaq', []);

    module.directive('sdFaq', function () {
        return {
            restrict: 'A',
            scope: {
                displayAll: '=?',
                initialFaqAmount: '@'
            },
            controller: ['$scope', function (scope) {
                var vm = this;
                var items = vm.items = [];

                scope.displayAll = angular.isDefined(scope.displayAll) ? scope.displayAll : false;

                vm.displayAll = scope.displayAll;

                vm.initialFaqAmount = scope.initialFaqAmount;

                vm.collapseSiblings = function (scope) {
                    angular.forEach(items, function (item) {
                        item !== scope && (item.active = false);
                    });
                };

                vm.showAllQuestions = function()  {
                    angular.forEach(vm.items, function (item) {
                        item.hidden = false;
                    });
                };

                vm.showInitialFaqAmount = function() {
                    for (var i = 0; i < vm.items.length; i++) {
                        var hidden = (i < vm.initialFaqAmount) ? false : true;
                        vm.items[i].hidden = hidden;
                    }
                };

                scope.$watch('displayAll', function (newValue) {
                    if (newValue) {
                        vm.showAllQuestions();
                    } else {
                        vm.showInitialFaqAmount();
                    }
                });

                vm.addItem = function (itemScope) {
                    items.push(itemScope);
                };
            }]
        };
    });

    module.directive('sdFaqItem', function () {
        return {
            restrict: 'A',
            require: '^sdFaq',
            scope: true,
            link: function (scope, element, attributes, faqController) {
                scope.active = false;
                scope.hidden = false;

                faqController.addItem(scope);

                if (element.index() >= parseInt(faqController.initialFaqAmount)) {
                    scope.hidden = true;
                }

                scope.toggle = function () {
                    scope.active = !scope.active;

                    if (scope.active) {
                        faqController.collapseSiblings(scope);
                    }
                };

                scope.$watch('hidden', function (newValue) {
                    newValue ? element.hide() : element.show();
                });

                scope.$watch('active', function (newValue) {
                    newValue ? element.addClass('active') : element.removeClass('active');
                });
            }
        };
    });

    module.directive('sdFaqItemToggle', [function () {
        return {
            restrict: 'A',
            replace: true,
            transclude: true,
            scope: false,
            template: '<a ng-click="toggle()" ng-href="" ng-transclude></a>',
            controller: ['$scope', function (scope) {
                scope.toggle = function () {
                    scope.$parent.toggle();
                };
            }]
        };
    }]);

    module.directive('sdFaqItemShowAll', [function () {
        return {
            link: function (scope) {
                scope.showAllToggle = function () {
                    scope.$parent.displayAll = !scope.$parent.displayAll;
                };
            },
            restrict: 'A',
            replace: true,
            transclude: true,
            require: '^sdFaq',
            scope: true,
            template: '<button class="btn btn-link" ng-click="showAllToggle()" ng-transclude></button>'
        };
    }]);

    module.animation('.faq-items .item', function () {
        return {
            beforeAddClass: function (e, t, n) {
                var a = $(e);
                'active' === t && a.find('.content').slideDown(n);
            },
            removeClass: function (e, t, n) {
                var a = $(e);
                'active' === t && a.find('.content').slideUp(n);
            }
        };
    });

}.call(this));
